import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '../store/index.js'
// const routerPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
// 	return routerPush.call(this, location).catch(error => error)
// }
import {
	MessageBox
} from 'element-ui';
import Home from '../views/Home.vue'
import Learndetail from '../views/Learn-detail.vue'
// import User from '../views/User.vue'
Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'Home',
	meta: {
		title: "创作社区",
		titles: "创作社区"

	},
	component: Home,

},
{
	path: '/Resource',
	name: '/Resource',
	meta: {
		title: "国际影展",
		keepAlive: true,
		isBack: false,
		titles: "国际影展"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Resource.vue'),

},
{
	path: '/Study-detail',
	name: 'Study-detail',
	meta: {
		title: "详情",
		titles: "详情"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Study-detail.vue'),

},
{
	path: '/Practice',
	name: 'Practice',
	meta: {
		title: "展映基地",
		keepAlive: true,
		isBack: false,
		titles: "展映基地"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Practice.vue'),

},
{
	path: '/Activity',
	name: 'Activity',
	meta: {
		title: "展映基地详情",
		keepAlive: true,
		isBack: false,
		titles: "展映基地详情"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Activity.vue'),

},
{
	path: '/Learn',
	name: 'Learn',
	meta: {
		title: "创作训练营",
		keepAlive: true,
		isBack: false,
		titles: "创作训练营"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Learn.vue'),

},


{
	path: '/Learn-detail',
	name: 'Learn-detail',
	meta: {
		title: "学习详情",
		titles: "学习详情",


	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	// component: () => import( /* webpackChunkName: "about" */ '../views/Learn-detail.vue')
	component: Learndetail,

},


{
	path: '/User',
	name: 'User',
	meta: {
		title: "会员中心",
		keepAlive: true,
		isBack: false,
		titles: "会员中心"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/User.vue'),
	// component: User,
	beforeEnter: (to, from, next) => {
		console.log(to);
		console.log(from);

		if (to.name == 'User') {
			let token = localStorage.getItem('AccessToken');
			if (token) {
				next()
			} else {
				MessageBox.confirm('您还未登录请先登录?', '提示', {
					confirmButtonText: '去登录',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					router.push("/Login")
				}).catch(() => {
					router.go(0)
				});

			}

		}
	}
},
{
	path: '/About',
	name: 'About',
	meta: {
		title: "关于星辰",
		keepAlive: true,
		isBack: false,
		titles: "关于星辰"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/About.vue'),
	// component: User,
	// beforeEnter: (to, from, next) => {

	// 	let token = localStorage.getItem('AccessToken')
	// 	if (token) {
	// 		next()
	// 	} else {
	// 		MessageBox.confirm('您还未登录请先登录?', '提示', {
	// 			confirmButtonText: '去登录',
	// 			cancelButtonText: '取消',
	// 			type: 'warning'
	// 		}).then(() => {
	// 			router.push("/Login")
	// 		}).catch(() => {
	// 			router.go(0)
	// 		});

	// 	}

	// }
},
{
	path: '/Login',
	name: 'Login',
	meta: {
		title: "登录",
		titles: "登录"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Login.vue')
},
{
	path: '/Register',
	name: 'Register',
	meta: {
		title: "注册",
		titles: "注册"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Register.vue')
},
{
	path: '/Find',
	name: 'Find',
	meta: {
		title: "忘记密码",
		titles: "忘记密码"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Find.vue'),

},

{
	path: '/success',
	name: 'success',
	meta: {
		title: "支付成功",
		titles: "支付成功"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/success.vue')
},
{
	path: '/Img',
	name: 'Img',
	meta: {
		title: "详情",
		titles: "详情"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Img.vue')
},
{
	path: '/alipay',
	name: 'alipay',
	meta: {
		title: "支付宝支付",
		titles: "支付宝支付"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/alipay.vue')
},
{
	path: '/legal',
	name: 'legal',
	meta: {
		title: "法律声明",
		keepAlive: true,
		isBack: false,
		titles: "法律声明"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/legal.vue'),

},
{
	path: '/contactus',
	name: 'contactus',
	meta: {
		title: "联系我们",
		keepAlive: true,
		isBack: false,
		titles: "联系我们"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/contactus.vue'),

},

{
	path: '/privacy',
	name: 'privacy',
	meta: {
		title: "隐私条款",
		keepAlive: true,
		isBack: false,
		titles: "隐私条款"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/privacy.vue'),

},

{
	path: '/service',
	name: 'service',
	meta: {
		title: "服务条款",
		keepAlive: true,
		isBack: false,
		titles: "服务条款"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/service.vue'),

},

{
	path: '/Learn-detailcopy',
	name: 'Learn-detailcopy',
	meta: {
		title: "学习详情",
		keepAlive: true,
		isBack: false,
		titles: "学习详情"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Learn-detailcopy.vue'),

},
{
	path: '/Examcopy',
	name: 'Examcopy',
	meta: {
		title: "测试",
		keepAlive: true,
		isBack: false,
		titles: "测试"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Examcopy.vue'),

},
{
	path: '/Exam',
	name: 'Exam',
	meta: {
		title: "考试",
		keepAlive: true,
		isBack: false,
		titles: "考试"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Exam.vue'),

},
{
	path: '/Exam-detail',
	name: 'Exam-detail',
	meta: {
		title: "测试详情",
		titles: "测试详情"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Exam-detail.vue'),
},
{
	path: '/Datum',
	name: 'Datum',
	meta: {
		title: "服务中心",
		keepAlive: true,
		isBack: false,
		titles: "服务中心"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/datum.vue'),

},
{
	path: '/read',
	name: 'read',
	meta: {
		title: "阅读",
		keepAlive: true,
		isBack: false,
		titles: "阅读"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/read.vue'),
},
{
	path: '/null',
	name: 'null',
	meta: {
		title: "首页",
		keepAlive: true,
		isBack: false,
		titles: "首页"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/null.vue'),
},
{
	path:'/Survey',
	name:'Survey',
	meta:{
		title:"创作者调研",
		keepAlive: true,
		isBack: false,
		titles: "创作者调研"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/Survey.vue'),

},
{
	path:'/Survey-detail',
	name:'Survey-detail',
	meta:{
		title:"创作者调研",
		keepAlive: true,
		isBack: false,
		titles: "创作者调研"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/Survey-detail.vue'),

},
{
	path:'/Survey-detail-my',
	name:'Survey-detail-my',
	meta:{
		title:"创作者调研",
		keepAlive: true,
		isBack: false,
		titles: "创作者调研"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/Survey-detail-my.vue'),

},
{
	path:'/crowdfunding/list',
	name:'crowdfunding-list',
	meta:{
		title:"众筹列表",
		keepAlive: true,
		isBack: false,
		titles: "众筹列表"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/crowdfunding/list.vue'),
},
{
	path:'/crowdfunding/detail',
	name:'crowdfunding-detail',
	meta:{
		title:"众筹详情",
		keepAlive: true,
		isBack: false,
		titles: "众筹详情"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/crowdfunding/detail.vue'),

},
{
	path:'/crowdfunding/pay-1',
	name:'crowdfunding-pay-1',
	meta:{
		title:"确认众筹",
		keepAlive: true,
		isBack: false,
		titles: "确认众筹"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/crowdfunding/pay-1.vue'),
},
{
	path:'/crowdfunding/pay-2',
	name:'crowdfunding-pay-2',
	meta:{
		title:"支付",
		keepAlive: true,
		isBack: false,
		titles: "支付"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/crowdfunding/pay-2.vue'),
},{
	path:'/crowdfunding/pay-3',
	name:'crowdfunding-pay-3',
	meta:{
		title:"支持成功",
		keepAlive: true,
		isBack: false,
		titles: "支持成功"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/crowdfunding/pay-3.vue'),
},{
	path:'/getOpenid',
	name:'getOpenid',
	meta:{
		title:"请稍等...",
		keepAlive: true,
		isBack: false,
		titles: "请稍等..."
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/getOpenId.vue'),
},{
	path:'/event/list',
	name:'event',
	meta:{
		title:"活动列表",
		keepAlive: true,
		isBack: false,
		titles: "活动列表"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/event/list.vue'),
},{
	path:'/event/detail',
	name:'event',
	meta:{
		title:"活动详情",
		keepAlive: true,
		isBack: false,
		titles: "活动详情"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/event/detail.vue'),
},{
	path:'/event/pay-1',
	name:'event',
	meta:{
		title:"支付",
		keepAlive: true,
		isBack: false,
		titles: "支付"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/event/pay-1.vue'),
},{
	path:'/event/pay-2',
	name:'event',
	meta:{
		title:"支付",
		keepAlive: true,
		isBack: false,
		titles: "支付"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/event/pay-2.vue'),
},{
	path:'/event/pay-3',
	name:'event',
	meta:{
		title:"支付",
		keepAlive: true,
		isBack: false,
		titles: "支付"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/event/pay-3.vue'),
}


]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
